module.exports = __webpack_public_path__ + "static/media/2.d7d7169c.png";